var map = {
	"./logo-2.png": 60,
	"./logo-3.png": 61,
	"./logo-4.png": 62,
	"./logo-5.png": 63,
	"./logo-6.png": 64,
	"./logo-7.png": 65,
	"./logo-8.png": 66,
	"./logo-dark.png": 40,
	"./logo-light-1.png": 31,
	"./logo-light-2.png": 32,
	"./logo-light-3.png": 33,
	"./logo-light-4.png": 34,
	"./logo-light-5.png": 35,
	"./logo-light-6.png": 36,
	"./logo-light-7.png": 37,
	"./logo-light-8.png": 38,
	"./logo-light.png": 29,
	"./logo-light1.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;